import { QueryOperator } from "./QueryOperator";

export class QueryExpression {
	public TypeName = "QueryExpression";
	public Property: string;
	public Operator: QueryOperator;
	public Value: any;
}